var _mask, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSellAndWin = function SvgSellAndWin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 110,
    height: 18,
    fill: "none"
  }, props), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "sellAndWin_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h110v10a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#sellAndWin_svg__a)",
    d: "M0 0h110v10a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.5,
    d: "M0 0h110zm111 10a9 9 0 0 1-9 9H8a9 9 0 0 1-9-9h2a7 7 0 0 0 7 7h94a7 7 0 0 0 7-7zM8 19a9 9 0 0 1-9-9V0h2v10a7 7 0 0 0 7 7zM111 0v10a9 9 0 0 1-9 9v-2a7 7 0 0 0 7-7V0z",
    mask: "url(#sellAndWin_svg__b)",
    style: {
      mixBlendMode: "screen"
    }
  }), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "sellAndWin_svg__a",
    x1: -20.5,
    x2: 71.011,
    y1: -4,
    y2: 79.626,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA8BE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.436,
    stopColor: "#4F318C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#4F318C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AA8BE7"
  })))));
};
export default SvgSellAndWin;